"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var Tag;
(function (Tag) {
    // Ошибки ядра «Платформы»
    Tag["Core"] = "core";
    // Глобальные ошибки, которые мы знаем (скорей всего принадлежат одному из проектов mail.ru)
    Tag["Global"] = "gl";
    // Проектные ошибки (критические для проекта)
    Tag["Self"] = "self";
    Tag["Async"] = "async";
    Tag["Ignore"] = "ign";
    Tag["Known"] = "known";
    Tag["API"] = "api";
    Tag["Shared"] = "shr";
    Tag["Ext"] = "ext";
    Tag["ThirdParty"] = "3rd";
    Tag["RB"] = "rb";
    // Неизвестные ошибки
    Tag["Unknown"] = "unk";
})(Tag = exports.Tag || (exports.Tag = {}));
//# sourceMappingURL=tag.js.map